import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { filter, Subject, takeUntil } from 'rxjs';
import { DeviationMapPopupComponent } from 'src/app/shared/components/deviation-map-popup/deviation-map-popup.component';
import { MyShipPopupComponent } from 'src/app/shared/components/my-ship-popup/my-ship-popup.component';
import { SubscribePopupComponent } from 'src/app/shared/components/subscribe-popup/subscribe-popup.component';
import {
  VesselQuestionnaireAction,
  VesselQuestionnairePopupComponent,
} from 'src/app/shared/components/vessel-questionnaire-popup/vessel-questionnaire-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';

@Component({
  selector: 'app-common-logo',
  templateUrl: './common-logo.component.html',
  styleUrls: ['./common-logo.component.scss'],
})
export class CommonLogoComponent implements OnInit, OnDestroy {
  notificationCount: any = 0;
  lastLoginDateTime: any;
  notifications: any;
  profileImageUrl: any;
  sideNavWidth = '60px';
  contentWidth = '60px';
  isOperatorsExpanded = false;
  isNotificationExpanded = false;
  notificationStatus: boolean = false;
  isToggleClick: boolean = false;
  selectedOperator: any = 'allShips';
  activeColor = '#007bff';
  defaultColor = '';
  loginDetails: any = {
    email: '',
  };
  isSidebarOpen = false;

  menuItems: any[] = [
    {
      icon: 'paid',
      label: 'Commercial Performance',
      // route: '/dashboard',
      expanded: true,
      subItems: [
        {
          icon: 'map',
          label: 'Fleet View',
          route: '/vp-fleetView',
        },
        {
          icon: 'layers',
          label: 'Charter Party Performance',
          route: '/vp-CharterpartyTable',
          expanded: false,
          subItems: [
            {
              icon: 'table_view',
              label: 'Table',
              route: '/vp-CharterpartyTable',
            },
            {
              icon: 'bar_chart',
              label: 'Charter Insights',
              route: '/vp-tcpGraphs',
            },
          ],
        },
        {
          icon: 'show_chart',
          label: 'Fleet Performance',
          route: '/vp-fleet-performance',
          // queryParams: { source: 'fleet-performance' },
        },
        {
          icon: 'description',
          label: 'Periodic Performance Report',
          route: '/vp-dialyReport',
        },
        // {
        //   icon: 'event_repeat',
        //   label: 'Periodic report',
        //   route: '/vp-periodicReport',
        //   onlyForMerakiOps: true,
        // },
        // {
        //   icon: 'pie_chart',
        //   label: 'Segment Composition',
        //   route: '/vp-pieChart',
        // },
        // {
        //   icon: 'bar_chart',
        //   label: 'Performance Against CP',
        //   route: '/vp-barChart',
        // },
      ],
    },
    {
      icon: 'engineering',
      label: 'Technical Performance',
      route: '/vp-tp-dashboard',
      expanded: false,
      subItems: [
        {
          icon: 'show_chart',
          label: 'Operational TP Graphs',
          route: '/vp-graphs',
        },
        {
          icon: 'timeline',
          label: 'Dynamic Fuel Model',
          route: '/vp-voyage-series',
          onlyForMeraki: true,
        },
        {
          icon: 'auto_graph',
          label: 'Digital Twin Comparison',
          route: '/vp-dt-comparison',
          onlyForMerakiAdmin: true,
        },
      ],
    },
  ];

  pcNavGroups: {
    id: string;
    label: string;
    icon: string;
    expanded: boolean;
    items: {
      icon: string;
      label: string;
      route: string;
      onlyForMerakiOps?: boolean;
    }[];
  }[] = [
      {
        id: 'views',
        label: 'Views',
        icon: 'location_on',
        expanded: true,
        items: [
          {
            icon: 'directions_boat',
            label: 'Fleet View',
            route: '/pc-fleetView',
          },
          { icon: 'bar_chart', label: 'Graph View', route: '/pc-graphical-view' },
        ],
      },
      {
        id: 'performance',
        label: 'Performance',
        icon: 'layers',
        expanded: true,
        items: [
          {
            icon: 'layers',
            label: 'Charter Party',
            route: '/pc-charter-performance',
          },
          {
            icon: 'build',
            label: 'Technical',
            route: '/pc-technical-performance',
          },
        ],
      },
      {
        id: 'actions',
        label: 'Actions',
        icon: 'tune',
        expanded: true,
        items: [
          { icon: 'tune', label: 'Optimization', route: '/pc-optimization' },
          // {
          //   icon: 'trending_up',
          //   label: 'Vessel Overspend Tracker',
          //   route: '/pc-consumption-exceptions',
          //   onlyForMerakiOps: true,
          // },
        ],
      },
      {
        id: 'weather',
        label: 'Port Weather',
        icon: 'wb_sunny',
        expanded: true,

        items: [
          { icon: 'home', label: 'Home', route: '/pw-home', onlyForMerakiOps: true, },
          { icon: 'assignment', label: 'My Request', route: '/pw-myrequest', onlyForMerakiOps: true, },
        ],
      },
    ];
  emItems: any[] = [
    {
      icon: 'assignment',
      label: 'IMO DCS',
      route: '/E-ImoDcs',
    },
    {
      icon: 'storage',
      label: 'CII',
      route: '/E-cii',
    },
    {
      icon: 'storage',
      label: 'FuelEU',
      route: '/E-fuelEU',
    },
    // {
    //   icon: 'storage',
    //   label: ' EU/UK Compliance',
    //   subItems: [
    //     {
    //       icon: 'map',
    //       label: 'EU ETS',
    //       route: '/E-euEts',
    //     },
    //           {
    //       icon: 'map',
    //       label: 'FuelEU',
    //       route: '/E-fuelEU',
    //     },
    //           {
    //       icon: 'map',
    //       label: 'UK MRV',
    //       route: '/E-uk-mrv',
    //     },
    //   ],
    // },
    {
      icon: 'storage',
      label: 'Emission Overview',
      route: '/E-Overview',
    },
  ];

  chItems: any[] = [
    {
      icon: 'dashboard',
      label: 'Voyage Summary',
      route: '/ch-allRequests',
    },
    {
      icon: 'request_page',
      label: 'My Request',
      expanded: false,
      subItems: [
        {
          icon: 'route',
          label: 'Heat Plans',
          route: '/ch-reportTable',
        },
        {
          icon: 'description',
          label: 'Final Reports',
          route: '/ch-finalReport',
        },
      ],
    },
    {
      icon: 'analytics',
      label: 'Data Analytics',
      expanded: true,
      subItems: [
        {
          icon: 'thermostat',
          label: 'Temperature Drop Algorithm',
          route: '/voyage-metrics',
          onlyForMerakiOps: true,
        },
        {
          icon: 'table_chart',
          label: 'Performance Benchmarking',
          route: '/ch-benchmark',
        },
      ],
    },
  ];

  pwItems: any[] = [
    {
      icon: 'home',
      label: 'Home',
      route: '/pw-home',
    },
    {
      icon: 'assignment',
      label: 'My Request',
      route: '/pw-myrequest',
    },
  ];
  // vSItems: any[] = [
  //   {
  //     icon: 'directions_boat',
  //     label: 'Vessel Reports',
  //     route: '/ms-requestForm',
  //   },
  //   {
  //     icon: 'history',
  //     label: 'Previous Reports',
  //     route: '/pc-vesselSummary',
  //   },
  // ];
  vSItems: any[] = [
    {
      icon: 'description',
      label: 'Generate Report',
      onlyForMerakiOps: true,
      expanded: false,
      subItems: [
        {
          icon: 'speed',
          label: 'Sailing Performance',
          expanded: false,
          subItems: [
            {
              icon: 'assignment',
              label: 'Voyage Performance ',
              route: '/cp-report',
            },
            // {
            //   icon: 'schedule',
            //   label: 'Periodic Report',
            //   route: '/priodic-form',
            // },
            {
              icon: 'cloud',
              label: 'All Weather',
              route: '/vp-all-weather',
            },
            {
              icon: 'analytics',
              label: 'CP Normalized Report',
              route: '/vp-cp-normalized',
            },
          ],
        },
        {
          icon: 'location_on',
          label: 'Port Performance',
          route: '/ms-requestForm',
        },
        {
          icon: 'local_fire_department',
          label: 'Cargo Heating',
          route: '/ch-allRequests',
        },
      ],
    },
  ];
  selectedImo: any;

  // 🔥 IMPORTANT FUNCTION
  toggleItem(item: any) {
    item.expanded = !item.expanded;
  }
  projectsItems: any[] = [
    {
      icon: 'route',
      label: 'Routing Engine',
      expanded: false,
      subItems: [
        {
          icon: 'sailing',
          label: 'Routing Request',
          route: '/routing-request',
          expanded: false,
          subItems: [
            {
              icon: 'add_circle',
              label: 'New Request',
              route: '/routing-request',
            },
            {
              icon: 'list_alt',
              label: 'Requests List',
              route: '/routing-request-list',
            },
          ],
        },
        {
          icon: 'admin_panel_settings',
          label: 'Route Manager',
          onlyForMerakiOps: true,
          expanded: false,
          route: '/rm-createdRoutes',
          subItems: [
            {
              icon: 'edit',
              label: 'Curate Route',
              route: '/rm-routingMap',
            },
            {
              icon: 'list_alt',
              label: 'View Created Routes',
              route: '/rm-createdRoutes',
            },
          ],
        },
        {
          icon: 'description',
          label: 'Initial Route Advice',
          route: '/vp-requestForm',
          queryParams: { type: 'initial' },
          onlyForMerakiOps: true,
        },
      ],
    },
    {
      icon: 'local_gas_station',
      label: 'Sailing Performance',
      subItems: this.menuItems,
      expanded: false,
      hoverImg: '../../../assets/images/s&c.jpg',
    },
    {
      icon: 'directions_boat',
      label: 'Port Performance',
      subItems: [],
      pcGroupedNav: true,
      expanded: false,
      hoverImg: '../../../assets/images/pc.jpg',
    },


    // {
    //   icon: 'wb_sunny',
    //   label: 'Port Weather',
    //   subItems: this.pwItems,
    //   expanded: false,
    // },
    {
      icon: 'eco',
      label: 'Emission Analytics',
      subItems: this.emItems,
      expanded: false,
    },
    {
      icon: 'query_stats',
      label: 'Vessel Reports',
      expanded: false,
      subItems: [
        this.vSItems[0],

        {
          icon: 'fact_check',
          label: 'Data Quality Check (DQC)',
          route: '/pc-data-qualitycheck',
          onlyForMerakiOps: true,
        },
        {
          icon: 'history',
          label: "Master's Report",
          route: '/ms-vesselSummary',
        },
      ],
    },
    {
      icon: 'local_fire_department',
      label: 'Cargo Heating',
      subItems: this.chItems,
      expanded: false,
    },

    {
      icon: 'attach_money',
      label: 'Disbursement',
      subItems: [
        {
          icon: 'dashboard',
          label: 'Dashboard',
          route: '/dis-dashboard',
        },
        {
          onlyForMerakiOps: true,
          icon: 'storage',
          label: 'Repository',
          route: '/dis-repository',
        },
        {
          onlyForMerakiOps: true,
          icon: 'account_balance_wallet',
          label: 'Proforma  DA',
          route: '/dis-pda',
        },
        {
          onlyForMerakiOps: true,
          icon: 'paid',
          label: 'Final DA',
          route: '/dis-fda',
        },
        {
          // onlyForMerakiOps: true,
          icon: 'description',
          label: 'Disbursement Tracker',
          route: '/dis-disbursment',
        },
      ],
      expanded: false,
      // url: 'https://disbursement.merakishippingservices.com',
    },
    {
      icon: 'schedule',
      label: 'Demurrage',
      subItems: [
        {
          icon: 'calculate',
          label: 'Manual Demurrage Calculation',
          route: '/d-form',
        },
      ],
      expanded: false,
      url: '',
    },
    {
      icon: 'oil_barrel',
      label: 'Tank Cleaning',
      subItems: [],
      expanded: false,
      url: '',
    },
    {
      icon: 'update',
      label: 'AI Insights',
      onlyForMerakiOps: true,
      expanded: false,
      subItems: [
        {
          icon: 'directions_boat',
          label: 'Saving Sheet',
          route: '/update-vessel-data',
        },
      ],
    },
  ];

  isHomePage = false;
  isNoLoaderPage = false;
  operatorIcon: boolean = true;
  username!: any;
  hoveredItem: any = null;
  hoverY = 0;
  tooltipLeft: number = 61;
  bungeUsername: any;
  module: any;
  isMeraki = false;
  isBunge = false;
  isZeronorth = false;
  isEiger = false;
  isAlcor = false;
  isElite = false;
  isCargoHeatingClient = false;

  // Combined flags
  isMerakiOrBunge = false;

  // Module flags
  isEmission = false;
  isVesselPerformance = false;
  isRoutingEngine = false;
  isPortConsumption = false;
  isCargoHeating = false;
  isHtmlReports = false;
  isPortWeather = false;
  isDisbursment = false;
  isDemurrage = false;

  // Theme
  isDark = false;
  @ViewChild('sidenav', { read: ElementRef }) sidenavRef!: ElementRef;
  subUsername: any;
  loginPic: any;
  email: any;
  private destroy$ = new Subject<void>();
  private sidebarCloseTimeout: any;
  greetingMessage: any;
  showNewYearPopup: any;
  ClientUsername: any;
  deviationCount: any;
  deviationStatus: boolean = false;
  dialogRef: any;
  speedCount: any;
  comments: any;
  selectedClient: string = 'all';
  clientOptions: string[] = [];
  filteredNotifications: any[] = [];
  filteredComments: any[] = [];
  isNotificationLoading: boolean = false;
  isRefreshing: boolean = false;
  activeNotificationTab: 'alerts' | 'comments' = 'alerts';

  constructor(
    private toastr: ToastrService,
    private requestFormService: RequestFormService,
    private dialog: MatDialog,
    private router: Router,
    private prequestFormService: PortRequestFormServiceService,
    private commonService: CargoheatingCommonService,
    private cdr: ChangeDetectorRef,
    private sharedDataService: DashboardService,
  ) {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe((event) => {
        this.syncModuleFromUrl(event.urlAfterRedirects);
        this.isHomePage = event.urlAfterRedirects === '/home';
        this.updateLoaderVisibility(event.urlAfterRedirects);
        this.commonService.redirectCargoHeatingClientIfRestricted(this.router);
        this.syncPcNavGroupsFromRoute(event.urlAfterRedirects);
      });
  }

  ngOnInit(): void {
    this.updateLoaderVisibility(this.router.url);
    this.loadFromStorage();
    this.syncModuleFromUrl(this.router.url);
    this.configureUser();
    this.configureSidebar();
    this.navigateToModule();
    this.commonService.redirectCargoHeatingClientIfRestricted(this.router);
    this.loadClientList();
    if (this.username !== 'Eiger Shipping') {
      // this.getNotifications();
      this.loadNotifications();
    }
    this.sharedDataService.selectedImo$.subscribe(() => {
      this.applyClientFilter();
    });
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (!event.urlAfterRedirects.startsWith('/vp-detailedView')) {
          localStorage.removeItem('selectedImo');
          this.sharedDataService.setSelectedImo(null);
        }

        this.applyClientFilter();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  isRestrictedUser(): boolean {
    return (
      this.username !== 'Bunge Shipping' &&
      this.username !== 'Eiger Shipping' &&
      this.username !== 'EMZoil Shipping'
    );
  }

  configureUser(): void {
    const imageMap: Record<string, string> = {
      'Meraki - Operations': '../../../assets/images/merakiLogo.png',
      'Eiger Shipping': '../../../assets/images/client-logo.png',
      'Zeronorth ZN': '../../../assets/images/zeroNorth.png',
      'Elite Shipping': '../../../assets/images/elite.png',
      'Bunge Shipping': '../../../assets/images/bunge_logo.png',
      'Alcor Shipping': '../../../assets/images/Alcor_logo.png',
      'Ethiopian Shipping & Logistics':
        '../../../assets/images/ethiopian.png',
    };

    this.profileImageUrl = imageMap[this.username] ?? '';
    this.operatorIcon = ![
      'Zeronorth ZN',
      'Elite Shipping',
      'Bunge Shipping',
    ].includes(this.username);

    if (
      this.loginPic !== undefined &&
      this.loginPic !== null &&
      this.loginPic !== 'null'
    ) {
      this.bungeUsername = `${this.subUsername}_${this.loginPic}`;
    } else {
      this.bungeUsername = this.username;
    }
    if (this.username === 'Eiger Shipping') {
      this.ClientUsername = 'Client Username';
      this.email = 'client@gmail.com';
    }
    if (this.username === 'Zeronorth ZN') {
      this.router.navigate(['/vp-requestForm'], {
        queryParams: { type: 'default' },
      });
      this.renameVesselPerformance();
    }
  }
  private updateLoaderVisibility(url: string): void {
    // Cargo Heating uses in-page skeleton loaders — hide the global ngx-ui-loader.
    const isCargoHeatingRoute =
      url.includes('/ch-') ||
      url.includes('/detailed-view') ||
      url.includes('/voyage-metrics') ||
      this.isCargoHeating;

    this.isNoLoaderPage =
      isCargoHeatingRoute ||
      [
        '/home',
        '/vp-database',
        '/vp-fleetView',
        '/E-cii',
        '/E-dashboard',
        '/E-ImoDcs',
        '/E-fuelEU',
        '/E-FuelUl-ShipView',
        '/E-tableview',
        '/E-euEts',
        '/E-uk-mrv',
        '/E-Uk-ShipView',
        '/vp-fleet-performance',
        '/routing-request-form',
        '/routing-request-list',
        '/routing-request',
        '/vp-requestForm',
        '/dis-meraki-ai',
        '/dis-dashboard',
        '/dis-disbursment',
        '/vp-CharterpartyTable',
        '/vp-shipView',
        '/vp-tcpGraphs',
        '/vp-periodicReportTable',
        '/vp-dialyReport',
        '/pc-home',
        '/dis-request-form',
        '/d-home',
        '/d-form',
        '/pc-myrequest',
        '/pc-database',
        '/pc-fleetView',
        '/pc-vesselView',
        '/vp-detailedView',
        '/pc-charter-performance',
        '/pc-technical-performance',
        '/pc-optimization',
        '/pw-home',
        '/pw-myrequest',
        '/admin/report-desk',
        '/vp-retriveForm'
        // '/pc-database',
        // '/pc-myrequest',
        // '/pc-fleetView',
        // '/pc-home'
      ].some((route) => url.startsWith(route));
  }

  get expandedSidebarWidth(): string {
    return this.isPortConsumption ? '280px' : '250px';
  }

  private applyExpandedSidebarWidth(): void {
    const width = parseInt(this.expandedSidebarWidth, 10);
    this.sideNavWidth = this.expandedSidebarWidth;
    this.contentWidth = this.expandedSidebarWidth;
    this.tooltipLeft = width;
  }

  configureSidebar(): void {
    if (this.isSidebarOpen) {
      this.applyExpandedSidebarWidth();
      this.expandActiveModule();
    }
  }
  expandActiveModule(): void {
    this.projectsItems.forEach((i) => (i.expanded = false));
    const active = this.projectsItems.find((i) => i.label === this.module);
    if (active) active.expanded = true;
    this.syncPcNavGroupsFromRoute();
  }

  togglePcNavGroup(group: { expanded: boolean }, event?: Event): void {
    event?.stopPropagation();
    group.expanded = !group.expanded;
  }

  isPcNavLinkActive(
    link: { route: string },
    url: string = this.router.url.split('?')[0],
  ): boolean {
    if (url === link.route || url.startsWith(link.route + '/')) {
      return true;
    }
    const detailRoutes: Record<string, string[]> = {
      '/pc-fleetView': ['/pc-vesselView'],
      '/pc-charter-performance': ['/pc-inside-charter-view'],
      '/pc-technical-performance': ['/pc-inside-tech-view'],
    };
    return (
      detailRoutes[link.route]?.some((route) => url.startsWith(route)) ?? false
    );
  }

  syncPcNavGroupsFromRoute(url?: string): void {
    const current = (url ?? this.router.url).split('?')[0];
    const isPcRoute =
      current.startsWith('/pc-') &&
      this.pcNavGroups.some((group) =>
        group.items.some((item) => this.isPcNavLinkActive(item, current)),
      );
    if (!isPcRoute) {
      return;
    }
    this.pcNavGroups.forEach((group) => {
      if (group.items.some((item) => this.isPcNavLinkActive(item, current))) {
        group.expanded = true;
      }
    });
  }

  getNormalizedCurrentUrl(url?: string): string {
    let rawUrl = url || this.router?.url;
    if ((!rawUrl || rawUrl === '/' || rawUrl === '') && typeof window !== 'undefined') {
      if (window.location.hash) {
        rawUrl = window.location.hash;
      } else if (window.location.pathname) {
        rawUrl = window.location.pathname;
      }
    }
    return (rawUrl || '')
      .replace(/^#\/?/, '/')
      .replace(/^\/?#\/?/, '/')
      .split('?')[0];
  }

  /* ---------------- NAVIGATION ---------------- */
  navigateToModule(): void {
    const currentUrl = this.getNormalizedCurrentUrl();
    const module = this.module;
    const user = this.username;

    const isMerakiOps = user === 'Meraki - Operations';
    const isZN = user === 'Zeronorth ZN';

    /* ---------------- ZERONORTH OVERRIDE ---------------- */
    if (isZN) {
      if (!currentUrl.startsWith('/vp-')) {
        this.router.navigate(['/vp-requestForm'], {
          queryParams: { type: 'default' },
        });
      }
      return;
    }

    /* ---------------- Admin pages (module-independent) ---------------- */
    if (currentUrl.startsWith('/admin/')) {
      return;
    }

    /* ---------------- Port Performance ---------------- */
    if (module === 'Port Performance') {
      if (!currentUrl.startsWith('/pc-')) {
        this.router.navigate([isMerakiOps ? '/pc-home' : '/pc-home']);
      }
      return;
    }
    /* ---------------- Routing Engine ---------------- */
    if (module === 'Routing Engine') {
      if (isMerakiOps) {
        const isInvalidVPForm =
          currentUrl.startsWith('/vp-requestForm') &&
          !currentUrl.includes('type=initial');
        if (
          (!currentUrl.startsWith('/vp-requestForm') &&
            !currentUrl.startsWith('/routing-request') &&
            !currentUrl.startsWith('/routing-request-list') &&
            !currentUrl.startsWith('/voyage-performance') &&
            !currentUrl.startsWith('/rm-')) ||
          isInvalidVPForm
        ) {
          this.router.navigate(['/vp-requestForm'], {
            queryParams: { type: 'initial' },
          });
        }
      } else {
        if (
          !currentUrl.startsWith('/routing-request-list') &&
          !currentUrl.startsWith('/routing-request') &&
          !currentUrl.startsWith('/voyage-performance')
        ) {
          this.router.navigate(['/routing-request-list']);
        }
      }
      return;
    }
    /* ---------------- CARGO HEATING ---------------- */
    if (module === 'Cargo Heating') {
      if (this.isCargoHeatingClient) {
        const allowed = this.commonService
          .getCargoHeatingClientAllowedRoutes()
          .map((route) => `/${route}`);
        if (!allowed.some((route) => currentUrl.startsWith(route))) {
          this.router.navigate([
            this.commonService.getCargoHeatingClientLandingRoute(),
          ]);
        }
      } else if (
        !currentUrl.startsWith('/ch-') &&
        !currentUrl.startsWith('/voyage-metrics') &&
        !currentUrl.startsWith('/detailed-view')
      ) {
        this.router.navigate(['/ch-allRequests']);
      }
      return;
    }

    /* ---------------- EMISSION ANALYTICS ---------------- */
    if (module === 'Emission Analytics') {
      if (!currentUrl.startsWith('/E-')) {
        this.router.navigate(['/E-dashboard']);
      }
      return;
    }
    /* ---------------- Demurrage ---------------- */
    if (module === 'Demurrage') {
      if (!currentUrl.startsWith('/d-')) {
        this.router.navigate(['/d-home']);
      }
      return;
    }
    if (module === 'Disbursement') {
      if (!currentUrl.startsWith('/dis-')) {
        this.router.navigate(['/dis-dashboard']);
      }
      return;
    }

    /* ---------------- Route Manager ---------------- */
    if (module === 'Route Manager') {
      if (!currentUrl.startsWith('/rm-')) {
        this.router.navigate(['/rm-routingMap']);
      }
      // If we simply want to enforce clicking Route Manager goes to /rm-routingMap,
      // it's handled below in toggleSubMenu directly.
      return;
    }

    /* ---------------- Sailing Performance ---------------- */
    if (module === 'Sailing Performance') {
      const isRoutingForm =
        currentUrl.startsWith('/vp-requestForm') &&
        currentUrl.includes('type=initial');
      const isRoutingPath =
        currentUrl.startsWith('/routing-request') ||
        currentUrl.startsWith('/routing-request-list') ||
        currentUrl.startsWith('/voyage-performance') ||
        currentUrl.startsWith('/rm-');
      if (!currentUrl.startsWith('/vp-') || isRoutingForm || isRoutingPath) {
        this.router.navigate(['/home']);
      }
      return;
    }
    /* ---------------- Technical Performance ---------------- */
    if (module === 'Technical Performance') {
      if (
        !currentUrl.startsWith('/vp-tp-dashboard') &&
        !currentUrl.startsWith('/vp-graphs') &&
        !currentUrl.startsWith('/vp-voyage-series') &&
        !currentUrl.startsWith('/vp-dt-comparison')
      ) {
        this.router.navigate(['/vp-tp-dashboard']);
      }
      return;
    }
    /* ---------------- Tank Cleaning ---------------- */
    if (module === 'Tank Cleaning') {
      if (!currentUrl.startsWith('/tc-')) {
        this.router.navigate(['/tc-form']);
      }
    }
    /* ---------------- Vessel Reports---------------- */
    if (module === 'Vessel Reports') {
      if (
        !currentUrl.startsWith('/ms-') &&
        !currentUrl.startsWith('/pc-data-qualitycheck') &&
        !currentUrl.startsWith('/admin/report-desk')
      ) {
        this.router.navigate(['/ms-vesselSummary']);
      }
    }

    if (module === "Master's Report") {
      if (!currentUrl.startsWith('/ms-vesselSummary')) {
        this.router.navigate(['/ms-vesselSummary']);
      }
      return;
    }
    if (module === 'AI Insights') {
      if (!currentUrl.startsWith('/update-vessel-data')) {
        this.router.navigate(['/update-vessel-data']);
      }
      return;
    }

    if (module === 'Data Quality Check (DQC)') {
      if (!currentUrl.startsWith('/pc-data-qualitycheck')) {
        this.router.navigate(['/pc-data-qualitycheck']);
      }
      return;
    }

    if (module === 'Port Weather') {
      if (!currentUrl.startsWith('/pw-')) {
        this.router.navigate(['/pw-home']);
      }
      return;
    }
  }

  renameVesselPerformance(): void {
    const item = this.projectsItems.find(
      (i) => i.label === 'Sailing Performance',
    );
    if (item) item.label = 'End Voyage Report';
  }
  loadFromStorage(): void {
    this.username = localStorage.getItem('username') ?? '';
    this.subUsername = localStorage.getItem('subUsername') ?? '';
    this.loginPic = localStorage.getItem('loginPic') ?? '';
    this.module = localStorage.getItem('module') ?? '';
    this.email = localStorage.getItem('email') ?? '';
    this.selectedOperator = localStorage.getItem('selectedRadio') ?? 'allShips';
    this.selectedClient =
      this.username === 'Meraki - Operations' ? 'all' : (this.username || '');

    this.isSidebarOpen = JSON.parse(
      localStorage.getItem('isSidebarOpen') || 'false',
    );
    this.computeFlags();
    if (this.email === 'null') this.email = '';
    const alreadyShown = localStorage.getItem('newYear2026Shown');

    if (!alreadyShown) {
      this.greetingMessage = `Welcome to 2026, ${this.username}.
Wishing you a year of safe operations, clear insights, and successful voyages.`;

      this.showNewYearPopup = true;
      setTimeout(() => {
        this.closeNewYearPopup();
      }, 5000);
      localStorage.setItem('newYear2026Shown', 'true');
    }
  }

  closeNewYearPopup() {
    this.showNewYearPopup = false;
  }
  private syncModuleFromUrl(url?: string): void {
    const cleanUrl = this.getNormalizedCurrentUrl(url);
    if (!cleanUrl || cleanUrl === '/' || cleanUrl.startsWith('/home') || cleanUrl.startsWith('/login')) {
      // After a (re)login the sidebar may still hold the previous session's module (e.g. Vessel
      // Reports); take the module the login just set, so nothing stays selected by mistake.
      let stored = localStorage.getItem('module') ?? '';
      if (cleanUrl.startsWith('/home') && stored === 'Vessel Reports') {
        stored = this.username === 'Bunge Shipping' ? 'Port Performance' : 'Sailing Performance';
        localStorage.setItem('module', stored);
      }
      if (stored !== this.module) {
        this.module = stored;
        this.computeFlags();
        this.expandActiveModule();
        this.cdr.markForCheck();
      }
      return;
    }
    let detectedModule = '';

    if (
      cleanUrl.startsWith('/ch-') ||
      cleanUrl.startsWith('/voyage-metrics') ||
      cleanUrl.startsWith('/detailed-view')
    ) {
      detectedModule = 'Cargo Heating';
    } else if (
      cleanUrl.startsWith('/vp-tp-dashboard') ||
      cleanUrl.startsWith('/vp-graphs') ||
      cleanUrl.startsWith('/vp-voyage-series') ||
      cleanUrl.startsWith('/vp-dt-comparison')
    ) {
      detectedModule = 'Technical Performance';
    } else if (cleanUrl.startsWith('/vp-')) {
      if (cleanUrl.startsWith('/vp-requestForm') && ((url && url.includes('type=initial')) || cleanUrl.includes('type=initial'))) {
        detectedModule = 'Routing Engine';
      } else {
        detectedModule = 'Sailing Performance';
      }
    } else if (
      cleanUrl.startsWith('/ms-') ||
      cleanUrl.startsWith('/pc-data-qualitycheck') ||
      cleanUrl.startsWith('/admin/report-desk')
    ) {
      detectedModule = 'Vessel Reports';
    } else if (cleanUrl.startsWith('/pc-')) {
      detectedModule = 'Port Performance';
    } else if (cleanUrl.startsWith('/tc-')) {
      detectedModule = 'Tank Cleaning';
    } else if (cleanUrl.startsWith('/pw-')) {
      detectedModule = 'Port Weather';
    } else if (cleanUrl.startsWith('/E-')) {
      detectedModule = 'Emission Analytics';
    } else if (cleanUrl.startsWith('/d-')) {
      detectedModule = 'Demurrage';
    } else if (cleanUrl.startsWith('/dis-')) {
      detectedModule = 'Disbursement';
    } else if (cleanUrl.startsWith('/rm-')) {
      detectedModule = 'Route Manager';
    } else if (cleanUrl.startsWith('/routing-')) {
      detectedModule = 'Routing Engine';
    }

    if (detectedModule) {
      this.module = detectedModule;
      localStorage.setItem('module', detectedModule);
      this.computeFlags();
      this.expandActiveModule();
      this.cdr.markForCheck();
    }
  }

  computeFlags(): void {
    this.isMeraki = this.username === 'Meraki - Operations';
    this.isBunge = this.username === 'Bunge Shipping';
    this.isZeronorth = this.username === 'Zeronorth ZN';
    this.isEiger = this.username === 'Eiger Shipping';
    this.isAlcor = this.username === 'Alcor Shipping';
    this.isElite = this.username === 'Elite Shipping';
    this.isEmission = this.module === 'Emission Analytics';
    this.isVesselPerformance = this.module === 'Sailing Performance';
    this.isRoutingEngine = this.module === 'Routing Engine';
    this.isPortConsumption = this.module === 'Port Performance';
    this.isCargoHeating = this.module === 'Cargo Heating';
    this.isHtmlReports = this.module === 'Vessel Reports';
    this.isPortWeather = this.module === 'Port Weather';
    this.isDisbursment = this.module === 'Disbursement';
    this.isDemurrage = this.module === 'Demurrage';
    this.isCargoHeatingClient =
      this.isCargoHeating && this.username !== 'Meraki - Operations';

    this.isMerakiOrBunge =
      this.isMeraki || this.isBunge || this.isAlcor || this.isElite;

    this.isDark = this.isDarkMode();
    if (this.router?.url) {
      this.updateLoaderVisibility(this.router.url);
    }
  }

  settingClick() {
    this.router.navigate(['/pc-settings']);
  }
  onboardingFormClick() {
    this.router.navigate(['/vp-onboardingForm']);
  }
  apiUsageClick() {
    this.router.navigate(['/api-usage']);
  }
  clientOwnershipClick() {
    this.router.navigate(['/client-ownership']);
  }
  reportDeskClick() {
    this.router.navigate(['/admin/report-desk']);
  }
  q88Click() {
    this.router.navigate(['/pc-Q88']);
  }
  openProfileVesselQuestionnaire() {
    const dialogRef = this.dialog.open(VesselQuestionnairePopupComponent, {
      width: '460px',
      maxWidth: '95vw',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      data: { showOnboardedOption: false },
    });

    dialogRef.afterClosed().subscribe((action?: VesselQuestionnaireAction) => {
      if (action === 'upload') {
        this.router.navigate(['/pc-settings'], {
          state: { fromOnboardingForm: true, fromQ88: true },
        });
        return;
      }

      if (action === 'history') {
        this.router.navigate(['/pc-Q88'], {
          state: { fromOnboardingForm: true },
        });
      }
    });
  }
  onboardingClick() {
    this.router.navigate(['/pc-OnboardingVessels']);
  }

  toggleOperators() {
    this.isOperatorsExpanded = !this.isOperatorsExpanded;
  }
  getNotifications() {
    this.requestFormService.getNotifications().subscribe((data) => {
      this.notificationCount = data.total_records;
      this.lastLoginDateTime = data.last_report_date_time;
      this.notificationStatus = data.status;
      this.comments = (data.comments || []).filter(
        (value: any, index: number, self: any) =>
          index ===
          self.findIndex(
            (t: any) =>
              t.imo === value.imo &&
              t.timestep === value.timestep &&
              t.comment === value.comment,
          ),
      );
      this.buildClientOptions();
      this.applyClientFilter();
    });
  }
  toggleNotification() {
    this.isNotificationExpanded = !this.isNotificationExpanded;
    if (this.isNotificationExpanded) {
      this.loadNotifications();
      if (
        this.username === 'Meraki - Operations' &&
        this.notificationStatus === false
      ) {
        let payload = {
          username: 'meraki',
          status: true,
        };
        this.requestFormService
          .updateNotificationStatus(payload)
          .subscribe((data) => {
            this.notificationStatus === true;
          });
      } else if (
        this.username === 'Bunge Shipping' &&
        this.notificationStatus === false
      ) {
        let payload = {
          username: 'bunge',
          status: true,
        };
        this.requestFormService
          .updateNotificationStatus(payload)
          .subscribe((data) => {
            this.notificationStatus === true;
          });
      }
    }
  }

  handleProfileImageChange(event: any): void {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.profileImageUrl = e.target.result;
      };

      reader.readAsDataURL(file);
    }
  }

  editProfileClick() {
    this.toastr.info(ToasterMessages.UnderDev);
  }

  onLogout() {
    localStorage.clear();
    this.module = '';
    this.projectsItems.forEach((i) => (i.expanded = false));
    this.router.navigateByUrl('');
  }
  openSidebar() {
    if (this.sidebarCloseTimeout) {
      clearTimeout(this.sidebarCloseTimeout);
      this.sidebarCloseTimeout = null;
    }
    if (!this.isSidebarOpen) {
      this.toggleSidebar();
    }
  }

  closeSidebar() {
    if (this.sidebarCloseTimeout) {
      clearTimeout(this.sidebarCloseTimeout);
    }
    this.sidebarCloseTimeout = setTimeout(() => {
      if (this.isSidebarOpen) {
        this.toggleSidebar();
      }
    }, 100);
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    localStorage.setItem('isSidebarOpen', JSON.stringify(this.isSidebarOpen));
    this.isToggleClick = true;
    this.cdr.markForCheck();
    this.projectsItems.forEach((item) => {
      if (item.label) {
        item.expanded = false;
      }
    });
    this.hoveredItem = null;

    if (this.isSidebarOpen === true) {
      this.applyExpandedSidebarWidth();
      this.projectsItems.forEach((item) => {
        if (this.module === item.label) {
          item.expanded = true;
        }
      });
    } else {
      this.sideNavWidth = '60px';
      this.contentWidth = '60px';
      this.isOperatorsExpanded = false;
      this.tooltipLeft = 60;
      this.isToggleClick = false;
    }
  }

  toggleDarkMode() {
    this.requestFormService.toggleDarkMode();
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  isEthiopian(): boolean {
    return this.username === 'Ethiopian';
  }
  userGuideClick() {
    if (this.module === 'Sailing Performance') {
      this.requestFormService.getUserManual().subscribe((data) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
      });
    } else if (this.module === 'Port Performance') {
      this.prequestFormService.getUserManual().subscribe((data) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
      });
    } else if (this.module === 'Cargo Heating') {
      this.commonService.getUserManual().subscribe((data: any) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
      });
    }
  }

  toggleSubMenu(item: any): void {
    this.isOperatorsExpanded = false;
    this.isNotificationExpanded = false;

    if (this.isSidebarOpen) {
      item.expanded = !item.expanded;
    }

    const label = item.label;
    const user = this.username;
    const module = this.module;
    const pic = this.bungeUsername;

    const isMerakiOps = user === 'Meraki - Operations';
    const isZN = user === 'Zeronorth ZN';
    const isBunge = user === 'Bunge Shipping';
    const isEiger = user === 'Eiger Shipping';
    const isAlcor = user === 'Alcor Shipping';
    const isElite = user === 'Elite Shipping';
    const isEthiopian = user === 'Ethiopian Shipping & Logistics';
    const isMerakiPic = pic === 'meraki_debh' || pic === 'meraki_gusi' || pic === 'meraki_sosa'||pic === 'meraki_masi'||pic === 'meraki_haja';
    const isDisbursement =
      pic === 'meraki_phjo' || pic === 'meraki_naba' || pic === 'meraki_maga';
    const isEmzoil = user === 'EMZoil Shipping';
    const isEmzoilPic = pic === 'emzoil_grace';

    const openPopup = () => {
      this.openPopupsSubscribe(item);
      item.expanded = false;
    };

    const reloadWithoutRefresh = () => {
      const currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl(currentUrl);
      });
    };

    const switchModule = (moduleName: string) => {
      if (module !== moduleName && module !== null) {
        localStorage.setItem('module', moduleName);
        this.module = moduleName;
        item.expanded = false;
        this.navigateToModule();
      }
    };
    /* ---------- POPUP CONDITIONS ---------- */
    const shouldOpenPopup =
      (label === 'End Voyage Report' && isZN) ||
      (label === 'Port Performance' && (isZN || isEiger || isDisbursement)) ||
      (label === 'Emission Analytics' &&
        (isZN || isEiger || isBunge || isDisbursement)) ||
      (label === 'Cargo Heating' &&
        (isZN ||
          isEiger ||
          isAlcor ||
          isEthiopian ||
          isMerakiPic ||
          isDisbursement ||
          isEmzoil)) ||
      (label === 'Sailing Performance' && (isBunge || isDisbursement)) ||
      (label === 'Disbursement' &&
        (isZN ||
          isAlcor ||
          isEthiopian ||
          isBunge ||
          isMerakiPic || isEmzoilPic)) ||
      (label === 'Demurrage' && (!isMerakiOps || isMerakiPic)) ||
      (label === 'Port Weather' && (!isMerakiOps || isDisbursement)) ||
      (label === 'Tank Cleaning' &&
        (!isMerakiOps || isMerakiPic || isDisbursement));

    if (label === 'Technical Performance') {
      localStorage.setItem('module', 'Technical Performance');
      this.module = 'Technical Performance';
      const cleanUrl = this.router.url.split('?')[0];
      if (cleanUrl === '/vp-tp-dashboard') {
        return;
      }
      item.expanded = true;
      this.router.navigate(['/vp-tp-dashboard']);
      return;
    }

    /* ---------- FINAL DECISION ---------- */
    if (shouldOpenPopup) {
      openPopup();
      return;
    } else {
      switchModule(label);
    }
  }
  onNestedMenuClick(m: any): void {
    if (m.label === 'Technical Performance') {
      localStorage.setItem('module', 'Technical Performance');
      this.module = 'Technical Performance';
      const cleanUrl = this.router.url.split('?')[0];
      if (cleanUrl === '/vp-tp-dashboard') {
        m.expanded = !m.expanded;
        return;
      }
      m.expanded = true;
      this.router.navigate(['/vp-tp-dashboard']);
      return;
    }
    if (m.subItems?.length) {
      m.expanded = !m.expanded;
    }
  }
  isItemActive(item: any): boolean {
    if (!item) return false;

    const currentUrl = this.getNormalizedCurrentUrl();

    // If item has a route, check if currentUrl matches route or alias routes
    if (item.route) {
      if (currentUrl === item.route || currentUrl.startsWith(item.route + '/')) {
        return true;
      }
      const routeAliases: Record<string, string[]> = {
        '/pc-data-qualitycheck': ['/admin/report-desk'],
        '/pc-fleetView': ['/pc-vesselView'],
        '/pc-charter-performance': ['/pc-inside-charter-view'],
        '/pc-technical-performance': ['/pc-inside-tech-view'],
      };
      if (
        routeAliases[item.route]?.some(
          (alias) => currentUrl === alias || currentUrl.startsWith(alias + '/'),
        )
      ) {
        return true;
      }
    }

    // If item has subItems, check if any child item is active
    if (item.subItems?.length) {
      if (item.subItems.some((child: any) => this.isItemActive(child))) {
        return true;
      }
    }

    // Only top-level items in projectsItems may match by module label
    const isTopLevel = this.projectsItems?.some((pi) => pi === item);
    if (isTopLevel) {
      return (
        item.label === this.module ||
        (item.label === 'End Voyage Report' && this.module === 'Sailing Performance')
      );
    }

    return false;
  }

  onOperatorChange(value: string) {
    if (value === 'myShips') {
      localStorage.setItem('selectedRadio', value);
      this.openMyShipsPopup();
    }
    if (value === 'allShips') {
      window.location.reload();
      localStorage.setItem('selectedRadio', value);
      localStorage.removeItem('selectedOperator');
    }
  }
  get isMyShipsDisabled(): boolean {
    return this.isHomePage;
  }

  openMyShipsPopup() {
    this.dialog.open(MyShipPopupComponent, {
      width: '405px',
      height: '296px',
      data: {},
    });
  }

  openPopupsSubscribe(item: any) {
    this.dialog.open(SubscribePopupComponent, {
      width: '430px',
      height: '407px',
      data: { item: item },
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
    });
  }

  showHoverImage(event: MouseEvent, item: any) {
    const element = event.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();

    this.hoverY = rect.top + rect.height / 2;
    this.hoveredItem = item;
    this.cdr.markForCheck();
  }
  isMerakiOperations(): boolean {
    return (this.username === 'Meraki - Operations' && this.loginPic !== 'demo');
  }

  /** Meraki Ops tenant users, including Meraki Admin roles. */
  isMerakiOpsOrDemo(): boolean {
    return this.username === 'Meraki - Operations' && this.loginPic !== 'demo';
  }

  isMerakiAdmin(): boolean {
    if (this.username !== 'Meraki - Operations') return false;

    const bungeKey = String(this.bungeUsername ?? '').toLowerCase();
    const picKey = String(this.loginPic ?? '').toLowerCase();
    const subKey = String(this.subUsername ?? '').toLowerCase();

    return (
      bungeKey === 'meraki_superadmin' ||
      bungeKey === 'meraki_admin' ||
      bungeKey === 'meraki_sosa' ||
      bungeKey === 'meraki_gusi' ||
      bungeKey.includes('admin') ||
      picKey.includes('admin') ||
      picKey === 'sosa' ||
      picKey === 'gusi' ||
      subKey.includes('admin') ||
      subKey === 'sosa' ||
      subKey === 'gusi'
    );
  }

  isMerakiUser(): boolean {
    return this.username === 'Meraki - Operations';
  }

  canShowMenuItem(item: any): boolean {
    if (!item) return true;

    // Rule 1: Digital Twin Comparison (only visible to Meraki Admin)
    if (item.route === '/vp-dt-comparison' || item.onlyForMerakiAdmin) {
      return this.isMerakiAdmin();
    }

    // Rule 2: Live Fuel Model (visible only to Meraki users: Admin, Operations, Demo)
    if (
      item.route === '/vp-voyage-series' ||
      item.onlyForMeraki
    ) {
      return this.isMerakiUser();
    }

    if (item.onlyForMerakiOps) {
      return this.isMerakiOperations();
    }

    return true;
  }

  canShowPcNavLink(link: any): boolean {
    return this.canShowMenuItem(link);
  }

  canShow(item: any): boolean {
    return this.canShowMenuItem(item);
  }

  showProfileVesselQuestionnaire(): boolean {
    if (this.username !== 'Meraki - Operations') {
      return false;
    }

    const roleKey = String(this.bungeUsername ?? '').toLowerCase();
    return roleKey !== 'superadmin' && roleKey !== 'admin' && roleKey === 'demo';
  }

  get moduleTitle(): string | null {
    const currentUrl = this.getNormalizedCurrentUrl();

    if (
      currentUrl.startsWith('/admin/report-desk') ||
      currentUrl.startsWith('/pc-data-qualitycheck')
    ) {
      return 'Vessel Reports Module > Data Quality Check';
    }

    if (currentUrl.startsWith('/ms-')) {
      return "Vessel Reports Module > Master's Report";
    }

    switch (this.module) {
      case 'Technical Performance':
        return 'Technical Performance Module';
      case 'Sailing Performance':
        return 'Sailing Performance Module';
      case 'Routing Engine':
        return 'Routing Engine Module';
      case 'Port Performance':
        return 'Port Performance Module';
      case 'Cargo Heating':
        return 'Cargo Heating Module';
      case 'Emission Analytics':
        return 'Environmental Performance Module';
      case 'Tank Cleaning':
        return 'Tank Cleaning Module';
      case 'Vessel Reports':
        return 'Vessel Reports Module';
      case 'Routing Request':
        return 'Routing Request Module';
      case 'Route Manager':
        return 'Route Manager Module';
      case 'Data Quality Check (DQC)':
        return 'Data Quality Check';
      case "Master's Report":
        return 'Masters Report Module';
      case 'AI Insights':
        return 'AI Insights Module';
      case 'Port Weather':
        return 'Port Weather';
      case 'Demurrage':
        return 'Demurrage Module';
      case 'Disbursement':
        return 'Disbursement Module';
      default:
        return null;
    }
  }

  isStringArray(arr: any[]): boolean {
    return Array.isArray(arr) && typeof arr[0] === 'string';
  }

  isNestedMenu(arr: any[]): boolean {
    return Array.isArray(arr) && arr.some((item) => item?.subItems?.length);
  }

  isSimpleMenu(arr: any[]): boolean {
    return (
      Array.isArray(arr) &&
      arr.length > 0 &&
      arr.every((item) => item?.route && !item?.subItems?.length)
    );
  }
  isMenuLink(item: any): boolean {
    return !!item?.route;
  }

  hasNestedMenu(item: any): boolean {
    return Array.isArray(item?.subItems) && item.subItems.length > 0;
  }
  getInitial(name: string): string {
    if (!name) return '?';

    const firstWord = name.trim().split(' ')[0];
    return firstWord.charAt(0).toUpperCase() + firstWord.slice(1).toLowerCase();
  }

  compareRouteClick() {
    this.requestFormService.getRouteCompare().subscribe((data) => {
      this.toastr.success(data.message);
    });
  }

  loadNotifications() {
    this.requestFormService
      .getDeviationNotifications(this.username)
      .subscribe((data) => {
        const deviation = data.deviation || [];
        const speed = data.speed || [];

        // Add type flag
        const deviationMapped = deviation.map((d: any) => ({
          ...d,
          type: 'deviation',
        }));

        const speedMapped = speed.map((s: any) => ({
          ...s,
          type: 'speed',
        }));

        // Merge + sort by latest
        this.notifications = [...deviationMapped, ...speedMapped].sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
        );

        this.deviationCount = deviation.length;
        this.speedCount = speed.length;
        this.buildClientOptions();
        this.applyClientFilter();
      });
  }
  onClientFilterChange(client: string) {
    this.selectedClient = client;
    const selectedUsername = this.getUsernameFromClient(client);
    this.loadDeviationNotificationsByUsername(selectedUsername);
    this.applyClientFilter();
  }
  selectAllClients() {
    this.selectedClient = 'all';
    this.loadDeviationNotificationsByUsername(this.username);
    this.applyClientFilter();
  }

  clearClientSelection() {
    this.selectedClient = '';
    this.loadDeviationNotificationsByUsername(this.username);
    this.applyClientFilter();
  }
  private loadClientList() {
    if (this.username !== 'Meraki - Operations') {
      this.clientOptions = [];
      return;
    }
    this.requestFormService.getClientList().subscribe({
      next: (data: any) => {
        const apiClients = Array.isArray(data)
          ? data
            .map((item: any) => (item?.client_name || '').trim())
            .filter((name: string) => !!name)
          : [];

        if (apiClients.length > 0) {
          this.clientOptions = Array.from(new Set(apiClients)).sort((a, b) =>
            a.localeCompare(b),
          );
        } else {
          this.buildClientOptions();
        }

        if (
          this.selectedClient &&
          this.selectedClient !== 'all' &&
          !this.clientOptions.includes(this.selectedClient)
        ) {
          this.selectedClient = 'all';
        }
      },
      error: () => {
        // Keep UI usable even if client master API fails.
        this.buildClientOptions();
      },
    });
  }

  private applyClientFilter() {
    const isMeraki = this.username === 'Meraki - Operations';
    const effectiveClient = isMeraki ? this.selectedClient : this.username;
    const includeNone = isMeraki && effectiveClient === '';
    const includeAll = isMeraki && effectiveClient === 'all';

    // Check if current page is VP Detailed View
    const isDetailedView = this.router.url.startsWith('/vp-detailedView');

    // Get selected IMO (or whichever storage/service you're using)
    const selectedImo = localStorage.getItem('selectedImo');

    if (includeNone) {
      this.filteredNotifications = [];
      this.filteredComments = [];
      return;
    }

    this.filteredNotifications = (this.notifications || []).filter((item: any) => {
      const vImo = String(item?.imo || '').trim();
      if (this.isDemoUser()) {
        if (!DEMO_VESSEL_PC.includes(vImo)) return false;
      } else if (this.isEmzoilGrace()) {
        const allowedImos = ['9378876', '9399480', '9438406', '9432048'];
        if (!allowedImos.includes(vImo)) return false;
      }

      const clientName = this.extractClientName(item);
      const clientMatch =
        includeAll || this.isClientMatch(clientName, effectiveClient);

      // Apply IMO filter only in detailed view
      const imoMatch = !isDetailedView || item.imo == selectedImo;

      return clientMatch && imoMatch;
    });

    this.filteredComments = (this.comments || []).filter((item: any) => {
      const vImo = String(item?.imo || '').trim();
      if (this.isDemoUser()) {
        if (!DEMO_VESSEL_PC.includes(vImo)) return false;
      } else if (this.isEmzoilGrace()) {
        const allowedImos = ['9378876', '9399480', '9438406', '9432048'];
        if (!allowedImos.includes(vImo)) return false;
      }

      const clientName = this.extractClientName(item);
      const clientMatch =
        includeAll || this.isClientMatch(clientName, effectiveClient);

      const imoMatch = !isDetailedView || item.imo == selectedImo;

      return clientMatch && imoMatch;
    });

  }

  private buildClientOptions() {
    if (this.username !== 'Meraki - Operations') {
      this.clientOptions = [];
      return;
    }
    if (this.clientOptions.length > 0) {
      return;
    }
    const allRecords = [
      ...(this.notifications || []),
      ...(this.comments || []),
    ];
    const uniqueClients = new Set<string>();

    allRecords.forEach((item: any) => {
      const clientName = this.extractClientName(item);
      if (clientName) uniqueClients.add(clientName);
    });

    this.clientOptions = Array.from(uniqueClients).sort((a, b) =>
      a.localeCompare(b),
    );

    if (
      this.selectedClient !== 'all' &&
      this.selectedClient !== '' &&
      !this.clientOptions.includes(this.selectedClient)
    ) {
      this.selectedClient = 'all';
    }
  }

  setNotificationTab(tab: 'alerts' | 'comments') {
    this.activeNotificationTab = tab;
  }

  getRelativeTime(dateStr: string | null | undefined): string {
    if (!dateStr) return '';
    try {
      const now = new Date().getTime();
      const date = new Date(dateStr).getTime();
      const diffMs = now - date;
      if (isNaN(diffMs) || diffMs < 0) return 'Recent';
      const diffSec = Math.floor(diffMs / 1000);
      if (diffSec < 60) return 'Just now';
      const diffMin = Math.floor(diffSec / 60);
      if (diffMin < 60) return `${diffMin}m ago`;
      const diffHour = Math.floor(diffMin / 60);
      if (diffHour < 24) return `${diffHour}h ago`;
      const diffDay = Math.floor(diffHour / 24);
      if (diffDay === 1) return 'Yesterday';
      if (diffDay < 7) return `${diffDay}d ago`;
      const diffWeeks = Math.floor(diffDay / 7);
      if (diffWeeks < 5) return `${diffWeeks}w ago`;
      return `${Math.floor(diffDay / 30)}mo ago`;
    } catch {
      return '';
    }
  }

  refreshAllNotifications() {
    this.isRefreshing = true;
    if (this.username !== 'Eiger Shipping') {
      this.loadNotifications();
    }
    if (this.username !== 'Meraki - Operations' && this.username !== 'Eiger Shipping') {
      this.getNotifications();
    }
    setTimeout(() => {
      this.isRefreshing = false;
    }, 800);
  }

  private isDemoUser(): boolean {
    const username = (this.username || '').toLowerCase();
    const subuser = (this.subUsername || '').toLowerCase();
    const pic = (this.loginPic || '').toLowerCase();
    return subuser === 'demo' || pic === 'demo' || username.includes('demo');
  }

  private isEmzoilGrace(): boolean {
    return (
      this.username === 'EMZoil Shipping' &&
      (this.subUsername || '').toLowerCase() === 'grace'
    );
  }

  private extractClientName(item: any): string {
    return (
      item?.client_name ||
      item?.client ||
      item?.company_name ||
      ''
    ).trim();
  }

  private getCanonicalClient(name: string): string {
    if (!name) return '';
    const n = name.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (n.includes('eiger') || n === 'client') return 'eiger';
    if (n.includes('bunge')) return 'bunge';
    if (n.includes('elite')) return 'elite';
    if (n.includes('alcor')) return 'alcor';
    if (n.includes('emz')) return 'emzoil';
    if (n.includes('ethiopian')) return 'ethiopian';
    if (n.includes('zeronorth') || n.includes('zn')) return 'zeronorth';
    if (n.includes('northwell')) return 'northwell';
    if (n.includes('meraki')) return 'meraki';
    return n;
  }

  private isClientMatch(itemClient: string, targetClient: string): boolean {
    if (!itemClient || !targetClient) return false;
    const c1 = this.getCanonicalClient(itemClient);
    const c2 = this.getCanonicalClient(targetClient);
    return !!c1 && !!c2 && c1 === c2;
  }

  private normalizeClientName(name: string): string {
    return (name || '')
      .trim()
      .toLowerCase()
      .replace(/shipping/g, '')
      .replace(/dmcc/g, '')
      .replace(/\s+/g, ' ');
  }
  private loadDeviationNotificationsByUsername(username: string) {
    this.isNotificationLoading = true;
    this.requestFormService.getDeviationNotifications(username).subscribe({
      next: (data) => {
        const deviation = data.deviation || [];
        const speed = data.speed || [];
        const selectedClientName =
          this.selectedClient && this.selectedClient !== 'all'
            ? this.selectedClient
            : this.username;

        const deviationMapped = deviation.map((d: any) => ({
          ...d,
          client_name: d.client_name || selectedClientName,
          type: 'deviation',
        }));

        const speedMapped = speed.map((s: any) => ({
          ...s,
          client_name: s.client_name || selectedClientName,
          type: 'speed',
        }));

        this.notifications = [...deviationMapped, ...speedMapped].sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
        );

        this.deviationCount = deviation.length;
        this.speedCount = speed.length;
        this.applyClientFilter();
      },
      error: () => {
        this.notifications = [];
        this.filteredNotifications = [];
      },
      complete: () => {
        this.isNotificationLoading = false;
      },
    });
  }

  private getUsernameFromClient(client: string): string {
    if (!client || client === 'all') {
      return this.username;
    }

    const clientToUsernameMap: Record<string, string> = {
      bunge: 'Bunge Shipping',
      eiger: 'Eiger Shipping',
      elite: 'Elite Shipping',
      alcor: 'Alcor Shipping',
      ethiopian: 'Ethiopian Shipping & Logistics',
      zeronorth: 'Zeronorth ZN',
      emzoil: 'EMZoil Shipping',
      northwell: 'Eiger Shipping',
    };

    const canonical = this.getCanonicalClient(client);
    return clientToUsernameMap[canonical] || this.username;
  }
  updateSpeedNotification(data: any) {
    data.is_read = true;
    let payload = {
      imo: data.imo,
      vessel_name: data.vessel_name,
      alert_type: data.alert_type,
    };
    this.requestFormService
      .updateSpeedNotificationPopup(payload)
      .subscribe((data) => { });
  }

  openMapPopup(data: any) {
    if (this.dialogRef) {
      return;
    }
    if (!data.is_read) {
      data.is_read = true;
      let payload = {
        imo: data.imo,
        ais_time: data.ais_time,
        forecast_time: data.forecast_time,
      };
      this.requestFormService
        .updateDeviationNotificationPopup(payload)
        .subscribe((data) => { });
    }
    this.dialogRef = this.dialog.open(DeviationMapPopupComponent, {
      width: '760px',
      height: '569px',
      data: data,
      disableClose: true,
    });
    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.dialogRef = null;
      this.loadNotifications();
      if (result) {
        this.isNotificationExpanded = false;
      }
    });
  }

  get unreadDeviationCount(): number {
    return (
      this.notifications?.filter((n: any) => n.is_read === false).length || 0
    );
  }

  get totalUnreadCount(): number {
    return (this.notificationCount || 0) + this.unreadDeviationCount;
  }

  isCargoHeatingReportsActive(): boolean {
    const url = this.router.url;
    return (
      url.startsWith('/ch-reportTable') ||
      url.startsWith('/ch-finalReport') ||
      url.startsWith('/ch-heatPlanGraph')
    );
  }
}

interface projectsItems {
  icon: string;
  label: string;
  subItems: string[];
  expanded: boolean;
  url?: string;
  hoverImg?: string;
  onlyForMerakiOps?: boolean;
}
